import { Dispatch } from "react";
import { LanguageAction } from "../../types";

export const setLanguage = (dispatch: Dispatch<LanguageAction>, languageTag: 'en' | 'mk'): void => {
  dispatch({
    type: "setLanguage",
    payload: languageTag,
  });
};

export const setEnglish = (dispatch: Dispatch<LanguageAction>): void => setLanguage(dispatch, "en");

export const setMacedonian = (dispatch: Dispatch<LanguageAction>): void => setLanguage(dispatch, "mk");
